/* eslint-disable prefer-destructuring */
import { Component } from "react";
import PropTypes from "prop-types";

export default class EditorAreaFocusState extends Component {
  static propTypes = {
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    children: PropTypes.func.isRequired,
  };

  static defaultProps = {
    onFocus: null,
    onBlur: null,
  };

  state = {
    focus: false,
  };

  handleFocus = () => {
    const { onFocus } = this.props;

    this.setState(
      {
        focus: true,
      },
      () => {
        if (onFocus) {
          onFocus();
        }
      },
    );
  };

  handleBlur = () => {
    const { onBlur } = this.props;

    this.setState(
      {
        focus: false,
      },
      () => {
        if (onBlur) {
          onBlur();
        }
      },
    );
  };

  render() {
    const { focus } = this.state;
    const { children } = this.props;

    return children({
      focus,
      bindFocus: {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
      },
    });
  }
}
